// src/config.js
export const SYSTEM_NAME = "BUAgents"; // 这里修改一次，全局都会变